/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import CursoForm from './CursoForm';
import * as validations from '../../validations/validations';
import * as cursoActions from '../../actions/cursoActions';
import * as contenidoActions from '../../actions/contenidoActions';
import * as tagActions from '../../actions/tagActions';
import * as tablasActions from '../../actions/tablasActions';
import * as moduloActions from '../../actions/moduloActions';
import * as usuarioActions from '../../actions/usuarioActions';
import withRouter from '../common/withRouter';


import {  useParams } from "react-router-dom";
import {  useLocation, useNavigate  } from "react-router-dom";

import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes} from '../../util/';
import $ from 'jquery';
import dayjs from 'dayjs';


import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';



class ManageCursoForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            
            headersTablaModulos:["Editar","Orden", "Modulo","Gratuito", "Fecha"],
            camposTablaModulos:[ "idModulo", "orden" , "idModulo", "gratuito", "fecha"],
            validacionesTablaModulos:[
                        {"name":"orden", "type":"int","max":100,"min":0}
            ],
            tipoTablaModulos:["button", "input","combo", "Checkbox",  "date"],
            errors:{},
            permisos:{},
			curso:{
                fechaInicio: new moment().format('DD/MM/YYYY'),
                imagenBanner:[]
            },
            archivos:[]
		};
		
	}
    
    
    componentDidMount(){
        usuarioActual(this, "Curso",true).then( (usuario)=>{
        let id=this.props.id;
        this.props.usuarioActions.getUsuarioCombo(14, usuario).then( ()=>{ 
           
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        });
        
        
        this.props.moduloActions.getModuloCombo(usuario).then( ()=>{ 
           
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        });
        
        this.props.cursoActions.getCursoCombo(usuario).then( ()=>{ 
           
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        }); 
        
        
        this.props.tagActions.getTagCombo(usuario).then( ()=>{ 
           
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        }); 
        
        
        /*
        this.props.contenidoActions.getArchivosDisponibles(29, ).then( archivos=>{
           this.setState({"archivos":archivos});
       })
        .catch(error=>{
          toastr.error(error);
        }); 
        */
        
        this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);
            if(id && id>0 ){
            
                this.props.cursoActions.getCurso(id, usuario).then( curso=>{
                    
                    
                    
                    this.props.contenidoActions.getArchivosDisponibles(29, usuario, curso.prefijo).then( archivos=>{
                        this.setState({"archivos":archivos});
                       })
                        .catch(error=>{
                          toastr.error(error);
                        }); 
                    
            
                    let tabla={
                        "nombre":"idsModulos",
                        "rows":curso.idsModulos
                    };
                    
                    if(curso.fechaInicio!=null){
                        curso.fechaInicio= new moment(curso.fechaInicio).format('DD/MM/YYYY');    
                    }else{
                        curso.fechaInicio= new moment().format('DD/MM/YYYY'); 
                    }

                    this.props.tablasActions.update(tabla);
             
                    this.setState({"curso":curso});
               })
                .catch(error=>{
                  toastr.error(error);
                }); 
            }
       })
        .catch(error=>{
          toastr.error(error);
        }); 
        
        

		
    }
    
    
     componentWillReceiveProps(nextProps) {	
         //console.log(this.props.tablas);
         //console.log("componentWillReceiveProps");
	}
    
    verModulo=(id)=> {
       let tabla={
            "nombre":"idsContenidos",
            "rows":[]
        };

        this.props.tablasActions.update(tabla);
        this.props.navigate("/modulo/"+id);
        //this.props.history.push("/modulo/"+id)
        //<Link to={"/modulo/"+row.idModulo}>
    }
    
    
     

    handleChangeCurrency=(value, name)=> {
        let data={
            'value':value,
            'name':name
        };
        this.handleChange({}, data);
    }
    
    handleChange=(event, data)=> {

        let curso = this.state.curso;
        let field= data.name;		
        let value= data.value;

    
        if(data.type == 'checkbox'){
            if(data.checked){
                value=1;
            }else{
                value=0;
            }    
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		curso[field[0]]= value;
		else{
             if(!curso[field[0]]){
                    curso[field[0]]={}
                }
			curso[field[0]][field[1]]= value;
		}
        
		
        this.setState({"curso": curso});
    }
    
    fechas=(fechasArreglo, fechasCadena)=>{
       
        let curso = this.state.curso;
        curso.fechaInicio = fechasCadena;
        curso.fechadayJS = fechasArreglo;
             //new moment(fechasCadena).format("MM-DD-YYYY");
             //this.state.nuevo.fechaInicioExamen[0].format("DD-MM-YYYY");
        this.setState({curso:curso});
    }
    
    onBuscar=(event)=>{
        event.preventDefault();
        let curso = this.state.curso;
        
        if(curso.prefijo!=""){
            this.props.contenidoActions.getArchivosDisponibles(29, this.props.user, curso.prefijo).then( archivos=>{
               this.setState({"archivos":archivos});
           })
            .catch(error=>{
              toastr.error(error);
            }); 
        }
        
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let curso=this.state.curso;
              
        if(!validations.requerido(curso.titulo)){
            errors.titulo=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(curso.descripcionCorta)){
            errors.descripcionCorta=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(curso.cantidadModulos)){
            errors.cantidadModulos=true;
            formIsValid=false;
        }
        
        if(!validations.requerido(curso.horasTotales)){
            errors.horasTotales=true;
            formIsValid=false;
        }
        
        if(!validations.requerido(curso.descripcionLarga)){
            errors.descripcionLarga=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(curso.imagenBanner)){
            errors.imagenBanner=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(curso.imagenThumbnails)){
            errors.imagenThumbnails=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }

    getTabla=(nombre)=>{
         
          let tabla=[...this.props.tablas.filter(tabla => tabla.nombre == nombre)];
        
        if(tabla.length>0){
            return tabla[0].rows;
        }
        return [];
    }

    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
        
        let newState=Object.assign({}, this.state.curso);
       
       let modulos=this.getTabla("idsModulos");
        
        modulos=Object.assign([], modulos);
        for(let i=0; i<modulos.length;i++){
            modulos[i].fechaInicio=new moment(modulos[i].fechaInicio).format("MM-DD-YYYY");
            modulos[i].fechaFin=new moment(modulos[i].fechaFin).format("MM-DD-YYYY");
        }
        newState.idsModulos=modulos;
        
        /*
        if(moment.isMoment(newState.fechaInicio)){
            newState.fechaInicio = new moment(newState.fechaInicio).format('YYYY/MM/DD hh:mm:ss');
        }else{
            newState.fechaInicio = moment(newState.fechaInicio, 'DD/MM/YYYY'); 
            newState.fechaInicio = new moment(newState.fechaInicio).format('YYYY/MM/DD hh:mm:ss');
        }
        */
        
        newState.fechaInicio = dayjs(this.state.curso.fechadayJS).format('YYYY/MM/DD hh:mm:ss');
        
        this.props.cursoActions.save(newState, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            let tabla={
            "nombre":"idsModulos",
            "rows":[]
        };
        this.props.tablasActions.update(tabla);
            this.props.navigate(-1);
        });
        
        
    }

       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <CursoForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.curso}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    archivos={genericFormattedForDropdown(this.state.archivos)}
                    onChangeCurrency={this.handleChangeCurrency}
                    cursoCombo={genericFormattedForDropdown(this.props.cursoCombo)}
                    tagCombo={genericFormattedForDropdown(this.props.tagCombo)}
                    headersTablaModulos={this.state.headersTablaModulos}
                    camposTablaModulos={this.state.camposTablaModulos}
                    validacionesTablaModulos={this.state.validacionesTablaModulos}
                    tipoTablaModulos={this.state.tipoTablaModulos}
                    usuarioCombo={genericFormattedForDropdown(this.props.usuarioCombo)}
                    moduloCombo={genericFormattedForDropdown(this.props.moduloCombo)}
                    fechas={this.fechas}
                    verModulo={this.verModulo}
                    onBuscar={this.onBuscar}
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    //let id = ownProps.match.params.id;
        
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        tagCombo:state.tagCombo,
        cursoCombo:state.cursoCombo,
        moduloCombo:state.moduloCombo,
        usuarioCombo:state.usuarioCombo,
        strings:state.strings,
        tablas:state.tablas,
        form:state.form
    }

}

function mapDispatchToProps(dispatch){

	return { 
        userActions:bindActionCreators(userActions, dispatch),
        menuActions:bindActionCreators(menuActions, dispatch),
        tablasActions: bindActionCreators(tablasActions, dispatch),
        tagActions: bindActionCreators(tagActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch),
        moduloActions: bindActionCreators(moduloActions, dispatch),
        usuarioActions: bindActionCreators(usuarioActions, dispatch),
	contenidoActions: bindActionCreators(contenidoActions, dispatch)
    };
}

export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageCursoForm));